export function navigate(path: string): void {
  if (window.location.pathname === path) return;
  history.pushState(null, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export function pushPath(path: string): void {
  if (window.location.pathname === path) return;
  history.pushState(null, "", path);
}
